import React, { ReactNode } from 'react'
import { BottomSheetProps as ReactSpringBottomSheetProps } from 'react-spring-bottom-sheet'

import { StyledBottomSheet, ContentContainer, Header, Title, CloseButton, GlobalStyle } from './BottomSheet.styled'

interface BottomSheetProps extends Omit<ReactSpringBottomSheetProps, 'children'> {
  children: ReactNode
  title?: string
  showCloseButton?: boolean
  showHeaderBorder?: boolean
  minHeight?: string
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  open,
  onDismiss,
  children,
  title,
  showCloseButton = true,
  showHeaderBorder = false,
  minHeight,
  snapPoints = ({ maxHeight }: { maxHeight: number }) => [maxHeight * 0.6, maxHeight * 0.9],
  blocking = true,
  ...props
}) => {
  const handleClose = (): void => {
    if (onDismiss) {
      onDismiss()
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      handleClose()
    }
  }

  return (
    <>
      <GlobalStyle />

      <StyledBottomSheet open={open} onDismiss={onDismiss} snapPoints={snapPoints} blocking={blocking} {...props}>
        {title && (
          <Header showBorder={showHeaderBorder}>
            <Title>{title}</Title>
            {showCloseButton && (
              <CloseButton onClick={handleClose} onKeyDown={handleKeyDown} aria-label="Fermer le panneau" type="button">
                ×
              </CloseButton>
            )}
          </Header>
        )}

        <ContentContainer>{children}</ContentContainer>
      </StyledBottomSheet>
    </>
  )
}

export type { ReactSpringBottomSheetProps }
